// Sucht eine App im App-Verzeichnis des TV ueber Name bzw. Aliasse - fuer
// Tizen (getInstalledApps) und LG (Katalog/Preloaded-Liste) gleichermassen.
//
// Warum eine Rangfolge statt "erster Treffer": am BU800 (Tizen 6.5) stehen
// vier Apps mit "youtube" im Namen - YoutubeKids, YoutubeTV, Youtube und
// YouTubeTestSuite - und YoutubeKids kam zuerst. Die Install-Seite meldete
// YouTube deshalb als "vorhanden als YoutubeKids". Genauso wurde fuer Google
// Cast die Einstellungs-App "Google Cast Settings" genommen.
//
// Regeln:
//  - Verglichen wird ohne Leer-/Sonderzeichen und ohne Gross-/Kleinschreibung
//    ("Disney+" = "disney", "googlecast-app" = "google cast").
//  - Ein Alias muss an einem WORTANFANG stehen. Sonst traefe "ard" die
//    "Samsung Keyboard" und "arte" jede App mit "smarte" im Namen.
//  - Rang: exakter Name vor Namensanfang vor Wort im Namen vor Treffer nur in
//    der Id.
//  - Nebenvarianten (Kids, Settings, Test, Service, ...) laufen ans Ende und
//    zaehlen NICHT als die App selbst: steht am TV nur "YoutubeKids", ist
//    YouTube eben nicht installiert.
//
// Bewusst ohne startsWith/includes: WebOS 3.5 laeuft auf Chromium 38.

// Was nach dem Alias im Namen uebrig bleibt und eine ANDERE App kennzeichnet.
// "music" steht drin, damit Amazon Music nicht als Prime Video (Alias
// "amazon") und YouTube Music nicht als YouTube durchgeht.
const VARIANT_WORDS = [
  'kids',
  'settings',
  'setting',
  'test',
  'suite',
  'service',
  'daemon',
  'dummy',
  'widget',
  'launcher',
  'provider',
  'deeplink',
  'helper',
  'agent',
  'beta',
  'music',
];

// "YoutubeTV" ist ein eigenes (US-)Produkt - "tv" allein als Rest ist deshalb
// eine Variante. Nicht in VARIANT_WORDS, weil "tv" sonst in jedem Rest steckt.
const VARIANT_EXACT = ['tv'];

export function normalize(s) {
  return String(s || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

function words(s, splitter) {
  return String(s || '')
    .toLowerCase()
    .split(splitter)
    .map(normalize)
    .filter((w) => !!w);
}

// Steht needle (normalisiert) an einem Wortanfang? Mehrteilige Aliasse
// ("prime video") duerfen dabei ueber Wortgrenzen laufen.
function atWordStart(parts, needle) {
  for (let i = 0; i < parts.length; i += 1) {
    if (parts.slice(i).join('').indexOf(needle) === 0) return true;
  }
  return false;
}

function needlesOf(options) {
  const opts = options || {};
  return (opts.aliases && opts.aliases.length ? opts.aliases : [opts.name])
    .map(normalize)
    .filter((n) => !!n);
}

function isVariant(name, needle) {
  const n = normalize(name);
  const at = n.indexOf(needle);
  const rest = at === -1 ? n : n.slice(0, at) + n.slice(at + needle.length);
  if (!rest) return false;
  if (VARIANT_EXACT.indexOf(rest) !== -1) return true;
  return VARIANT_WORDS.some((w) => rest.indexOf(w) !== -1);
}

// Bewertet einen Eintrag gegen einen Alias. null = kein Treffer, sonst
// { rank, variant } - kleiner Rang ist besser.
function score(entry, needle) {
  const name = entry.name || '';
  const n = normalize(name);
  let rank = -1;
  if (n && n === needle) rank = 0;
  else if (n && n.indexOf(needle) === 0) rank = 1;
  else if (atWordStart(words(name, /[^a-z0-9]+/), needle)) rank = 2;
  else if (atWordStart(words(entry.id, /[.\-_]+/), needle)) rank = 3;
  if (rank === -1) return null;
  return { rank: rank, variant: isVariant(name, needle) };
}

// Alle passenden Eintraege, beste zuerst. Jeder Treffer traegt `variant`.
export function rankAppMatches(list, options) {
  const needles = needlesOf(options);
  if (!needles.length || !list || !list.length) return [];
  const hits = [];
  list.forEach((entry, index) => {
    let best = null;
    needles.forEach((needle) => {
      const s = score(entry, needle);
      if (!s) return;
      if (!best || s.variant < best.variant || (s.variant === best.variant && s.rank < best.rank)) best = s;
    });
    if (best) hits.push({ entry: entry, index: index, rank: best.rank, variant: best.variant });
  });
  hits.sort((a, b) => a.variant - b.variant || a.rank - b.rank || a.index - b.index);
  return hits.map((h) => ({ entry: h.entry, variant: h.variant }));
}

// Der beste Treffer, der KEINE Nebenvariante ist - oder null.
export function findAppMatch(list, options) {
  const hit = rankAppMatches(list, options).filter((h) => !h.variant)[0];
  return hit ? hit.entry : null;
}



// WEBPACK FOOTER //
// ./src/helpers/Cast/appMatch.js